import { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import About from '../components/About';
import WhyChooseUs from '../components/WhyChooseUs';
import ProductGallery from '../components/ProductGallery';
import FAQs from '../components/FAQs';
import Contact from '../components/Contact';
import QuoteModal from '../components/QuoteModal';
import ContactModal from '../components/ContactModal';
import ProductDetailModal from '../components/ProductDetailModal';
import PageModal from '../components/PageModal';
import PrivacyModal from '../components/PrivacyModal';
import Testimonials from '../components/Testimonials';

const Home = () => {
  const [modalContent, setModalContent] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [pageModalSlug, setPageModalSlug] = useState(null);

  const handleOpenModal = (type, slug = null) => {
    switch (type) {
      case 'quote':
        setModalContent('quote');
        break;
      case 'contact':
        setModalContent('contact');
        break;
      case 'privacy':
        setModalContent('privacy');
        break;
      case 'page':
        setPageModalSlug(slug);
        break;
      default:
        setModalContent(null);
    }
  };

  const handleOpenProductModal = (product) => {
    setSelectedProduct(product);
    setModalContent('product');
  };

  const handleCloseModal = () => {
    setModalContent(null);
    setSelectedProduct(null);
    setPageModalSlug(null);
  };

  return (
    <div>
      <Header onOpenModal={handleOpenModal} />
      <section id="home" className="min-h-screen">
        <Hero onOpenModal={handleOpenModal} />
      </section>

      <section id="products" className="min-h-screen">
        <ProductGallery onOpenModal={handleOpenModal} onOpenProductModal={handleOpenProductModal} />
      </section>

      <section id="about" className="min-h-screen">
        <About />
      </section>

      <section id="testimonials" className="min-h-screen">
        <Testimonials />
      </section>

      <section id="faqs" className="min-h-screen">
        <FAQs />
      </section>

      <section id="contact" className="min-h-screen">
        <Contact onOpenModal={handleOpenModal} />
      </section>
      <Footer onOpenModal={handleOpenModal} />

      {/* Modal Content */}
      {modalContent === 'quote' && (
        <QuoteModal
          isOpen={true}
          onClose={handleCloseModal}
        />
      )}

      {modalContent === 'contact' && (
        <ContactModal
          isOpen={true}
          onClose={handleCloseModal}
        />
      )}

      {modalContent === 'product' && (
        <ProductDetailModal
          isOpen={true}
          onClose={handleCloseModal}
          product={selectedProduct}
          onAddToQuote={() => handleOpenModal('quote')}
        />
      )}

      {modalContent === 'privacy' && (
        <PrivacyModal
          isOpen={true}
          onClose={handleCloseModal}
        />
      )}

      {pageModalSlug && (
        <PageModal
          isOpen={true}
          onClose={handleCloseModal}
          slug={pageModalSlug}
        />
      )}
    </div>
  );
};

export default Home;